import { render } from "./UiMenu.vue?vue&type=template&id=236071f9&scoped=true&ts=true"
import script from "./UiMenu.vue?vue&type=script&lang=ts"
export * from "./UiMenu.vue?vue&type=script&lang=ts"

import "./UiMenu.vue?vue&type=style&index=0&id=236071f9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236071f9"]])

export default __exports__